export default __webpack_public_path__ + "static/char-s-18-kr-c19aeb1705403e70a291b06236b6ed65.webp";